import { InkleAIChatSlider } from "components/InkleAI/InkleAIChatSlider";
import { InkleAIOnboardingSlider } from "components/InkleAI/InkleAIOnboardingSlider";
import { SidebarStickyItem } from "components/Sidebar/SidebarStickyItem";
import { INKLE_AI_BUTTON_CLICKED } from "constants/analyticsEvents";
import { AI_ONBOARDING_STEP_KEY, ONBOARDING_STATUS } from "constants/inkleAI";
import { useAnalytics } from "hooks/useAnalytics";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { useCurrentEntity } from "hooks/useCurrentEntity";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useModal } from "hooks/useModal";
import { useGetEntitiesQuery } from "store/apis/group";
import { useGetOnBoardingQuery } from "store/apis/inkleAI";
import { clearInkleAIMessage } from "store/slices/inkleAISlider";
import InkleAiIcon from "static/images/InkleAIIcon.png";

const InkleAiIconComponent = () => (
  <img className="t-h-4 t-w-4" src={InkleAiIcon} alt="Inkle AI" />
);

export const InkleAiNavItem = () => {
  const inkleAISlider = useModal();
  const chatSlider = useModal();
  const { trackEvent } = useAnalytics();
  const dispatch = useAppDispatch();

  const { prefilledMessage: externalMessage } = useAppSelector(
    (state) => state.inkleAISlider
  );

  const { data: { groups: [group] = [] } = {} } = useGetEntitiesQuery();
  const currentEntity = useCurrentEntity();
  const { entities } = useCurrentGroupContext();
  const currentEntityId = useCurrentEntityId();

  const { data, isSuccess } = useGetOnBoardingQuery({
    step_key: AI_ONBOARDING_STEP_KEY,
  });

  const isChatSliderOpen = chatSlider.isOpen || Boolean(externalMessage);
  const aiChannelId = group?.ai_channel_url;
  const entityName = currentEntity?.name || "";

  const handleChatSliderClose = () => {
    chatSlider.close();
    dispatch(clearInkleAIMessage());
  };

  const handleGetStarted = () => {
    if (!isSuccess || !data) return;

    trackEvent(INKLE_AI_BUTTON_CLICKED);

    if (data.status_display === ONBOARDING_STATUS.NOT_STARTED && !aiChannelId) {
      inkleAISlider.open();
    } else {
      chatSlider.open();
    }
  };

  if (!isSuccess) {
    return null;
  }

  return (
    <>
      <SidebarStickyItem
        icon={InkleAiIconComponent}
        label="Inkle AI"
        onClick={handleGetStarted}
      />

      <InkleAIOnboardingSlider
        open={inkleAISlider.isOpen}
        onClose={inkleAISlider.close}
        chatSliderOpen={chatSlider.open}
        uuid={data?.uuid || ""}
      />

      <InkleAIChatSlider
        key={externalMessage ?? ""}
        open={isChatSliderOpen}
        onClose={handleChatSliderClose}
        aiChannelId={aiChannelId}
        entityName={entityName}
        entities={entities}
        currentEntityId={currentEntityId}
        initialPrefilledMessage={externalMessage}
      />
    </>
  );
};
